// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var mirrorEasing=function mirrorEasing(easing){return function(p){return p<=0.5?easing(2*p)/2:(2-easing(2*(1-p)))/2;};};export{mirrorEasing};